import { __spreadArray, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';

var ToastContext = React__default.createContext({
    toasts: [],
    show: function () { },
    close: function () { },
    closeAll: function () { },
});
var useToast = function () {
    var _a = React__default.useState([]), toasts = _a[0], setToasts = _a[1];
    var idRef = React__default.useRef(0);
    var close = React__default.useCallback(function (id) {
        setToasts(function (state) { return state.filter(function (toast) { return toast.id !== id; }); });
    }, []);
    var closeAll = React__default.useCallback(function () {
        setToasts([]);
    }, []);
    var show = React__default.useCallback(function (options) {
        idRef.current += 1;
        var id = idRef.current;
        setToasts(function (state) { return __spreadArray(__spreadArray([], state, true), [__assign(__assign({ id: id }, options), { duration: options.duration || 5000 })], false); });
    }, []);
    return {
        toasts: toasts,
        show: show,
        close: close,
        closeAll: closeAll,
    };
};

export { ToastContext, useToast };
//# sourceMappingURL=ToastContext.js.map
